import { useEffect } from "react";
import { runsOnDevice } from "./api/client.js";

/**
 * Tell the APK the first screen is ready, so it shows the app and drops its
 * launch overlay (MainActivity.hideLaunchCover). The owner wants the overlay
 * to stay until Home is ready, and Home to open on its real content rather
 * than a placeholder that fills in afterwards (2026-09-26), so Home decides
 * (launchReady, from HomePage); any other first screen is ready once drawn.
 * HOME_WAIT_MAX_MS keeps a Home that never settles from holding the overlay.
 *
 * Timers, not animation frames: in the APK the page is invisible until this
 * fires, and an invisible WebView may not run animation frames at all.
 * Outside the APK there is nothing to tell.
 */
const HOME_WAIT_MAX_MS = 5_000;

let told = false;

export function launchReady(): void {
  if (told) return;
  told = true;
  const cap = (globalThis as { Capacitor?: { nativePromise?: (plugin: string, method: string, options: object) => Promise<unknown> } })
    .Capacitor;
  if (!runsOnDevice() || typeof cap?.nativePromise !== "function") return;
  void cap.nativePromise("SystemBars", "launchDone", {}).catch(() => undefined);
}

/** Rendered after <App />: its effect runs once the whole first screen has committed. */
export function LaunchDone(): null {
  useEffect(() => {
    // Outside the router (it lives inside <App />), so the address is read directly.
    const timer = setTimeout(launchReady, window.location.pathname === "/" ? HOME_WAIT_MAX_MS : 50);
    return () => clearTimeout(timer);
  }, []);
  return null;
}
